// Words that are acronyms and should stay uppercase in a humanized label, so
// e.g. ID_FRONT renders as "ID Front" rather than "Id Front".
const UPPERCASE_LABEL_WORDS = new Set(['id', 'bvn']);
/**
 * Turns a SCREAMING_SNAKE_CASE identifier (e.g. an enum value such as
 * PROOF_OF_BUSINESS_ADDRESS) into a title-cased, human-readable label for
 * display ("Proof Of Business Address"). Known acronyms (see
 * UPPERCASE_LABEL_WORDS) stay uppercased.
 */
export const snakeToTitleCase = (snakeStr) => snakeStr
    .toLowerCase()
    .split('_')
    .map((word) => UPPERCASE_LABEL_WORDS.has(word)
    ? word.toUpperCase()
    : word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
//# sourceMappingURL=snakeToTitleCase.js.map